// Nosto Search Implementation
// File used to override the default search functionality of the theme to enable Nosto search.
// Salesfire search disabled at theme level due to several issues with cross compatibility with Nosto search.

// Store original functions for debugging
window._originalSearchFunctions = {
  toggleSearch: window.toggleSearch,
  openQuickSearch: window.openQuickSearch,
  closeQuickSearch: window.closeQuickSearch
};

// Override toggleSearch function
window.toggleSearch = function() {
  openNostoSearch();
  return false;
};

// Override openQuickSearch function
window.openQuickSearch = function() {
  openNostoSearch();
  return false;
};

// Override closeQuickSearch function
window.closeQuickSearch = function() {
  closeNostoSearch();
  return false;
};

// Completely disable focus trap creation for quick search
const originalCreateFocusTrap = window.createFocusTrap;
window.createFocusTrap = function(element, options) {
  // If this is the quick search modal, return a dummy trap
  if (element && (
    element.hasAttribute('data-quick-search') || 
    element.querySelector('[data-quick-search]') ||
    element.id === 'MainQuickSearch'
  )) {
    return {
      activate: function() {},
      deactivate: function() {}
    };
  }
  
  // For other elements, use original function if available
  if (typeof originalCreateFocusTrap === 'function') {
    try {
      return originalCreateFocusTrap.call(this, element, options);
    } catch (error) {
      return {
        activate: function() {},
        deactivate: function() {}
      };
    }
  }
  
  // Fallback dummy trap
  return {
    activate: function() {},
    deactivate: function() {}
  };
};

function openNostoSearch() {
  const nostoOverlay = document.getElementById('nosto-search-overlay');
  const searchInput = document.getElementById('nosto-search-input');
  
  if (nostoOverlay && searchInput) {
    // Show the overlay
    nostoOverlay.setAttribute('aria-hidden', 'false');
    
    // Focus the input with a small delay for animation
    setTimeout(() => {
      searchInput.focus();
      searchInput.select();
    }, 100);
    
    // Update all search button states
    updateAllSearchButtonStates(true);
  }
}

function closeNostoSearch() {
  const nostoOverlay = document.getElementById('nosto-search-overlay');
  
  if (nostoOverlay) {
    // Hide the overlay
    nostoOverlay.setAttribute('aria-hidden', 'true');
    
    // Update all search button states
    updateAllSearchButtonStates(false);
    
    // Return focus to the search button that was clicked
    const searchButtons = document.querySelectorAll('[data-search]');
    if (searchButtons.length > 0) {
      searchButtons[0].focus();
    }
  }
}

function updateAllSearchButtonStates(isOpen) {
  const searchButtons = document.querySelectorAll(`
    [data-search],
    [data-search-toggle],
    [href="#quick-search"],
    .header__search-button,
    .search-toggle
  `);
  
  searchButtons.forEach(button => {
    button.setAttribute('aria-expanded', isOpen.toString());
  });
}

function hijackAllSearchButtons() {
  const searchButtonSelectors = [
    '[data-search]',
    '[data-search-toggle]',
    '[href="#quick-search"]',
    '.header__search-button',
    '.search-toggle',
    '.header__icon-touch--search'
  ];
  
  searchButtonSelectors.forEach(selector => {
    const buttons = document.querySelectorAll(selector);
    buttons.forEach(button => {
      // Remove existing click listeners if possible
      const newButton = button.cloneNode(true);
      button.parentNode.replaceChild(newButton, button);
      
      // Add our hijacked click handler
      newButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        openNostoSearch();
      }, { capture: true });
      
      // Also handle keyboard events
      newButton.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          e.stopImmediatePropagation();
          e.stopPropagation();
          openNostoSearch();
        }
      }, { capture: true });
    });
  });
}

// Run immediately
hijackAllSearchButtons();

// Also run when DOM is ready as backup
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', hijackAllSearchButtons);
} else {
  hijackAllSearchButtons();
}

// Listen for escape key globally
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    const nostoOverlay = document.getElementById('nosto-search-overlay');
    if (nostoOverlay && nostoOverlay.getAttribute('aria-hidden') === 'false') {
      closeNostoSearch();
    }
  }
});

// Listen for clicks outside the search modal
document.addEventListener('click', function(e) {
  const nostoOverlay = document.getElementById('nosto-search-overlay');
  if (nostoOverlay && 
      nostoOverlay.getAttribute('aria-hidden') === 'false' && 
      !nostoOverlay.contains(e.target)) {
    closeNostoSearch();
  }
});

// Listen for custom close event from Nosto search modal
window.addEventListener('nosto-search-close-requested', function() {
  closeNostoSearch();
});
